import React from 'react';
import HeaderSortCell from './HeaderSortCell';
import DataCell from './DataCell.js';

export const renderCell = (sortConfig, handleOnSortClick) => {
  return ({ isHeaderCell, column, row }) => {
    if (isHeaderCell) {
      return (
        <HeaderSortCell
          isHeaderCell={isHeaderCell}
          column={column}
          sortConfig={sortConfig}
          handleOnSortClick={handleOnSortClick}
        />
      );
    }
    return <DataCell row={row} column={column} />;
  };
};